import classNames from 'classnames';
import numbro from 'numbro';
import { useTranslations } from '@/app/i18n.js';
import { pricePresentation } from './bookingSlotPresentation.js';

export default function BookingTimeSlot({ time, slot, available, selected, prices, remaining, capacity, disabled = false, onSelect }) {
    const __ = useTranslations();
    const presentation = pricePresentation(slot?.price, prices);
    const handleClick = () => {
        if (available) {
            onSelect?.();
            return;
        }

        const alternatives = document.getElementById('alternative-games');
        alternatives?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        document.getElementById('alternatives-title')?.focus({ preventScroll: true });
    };

    return <button type="button" disabled={disabled} aria-pressed={selected} onClick={handleClick}
        className={classNames({
            'border text-center font-semibold tracking-tight w-full py-6 3xl:py-8 gap-0 md:gap-2 flex flex-col items-center justify-center relative overflow-hidden min-h-[44px] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-[-2px]': true,
            'border-gray-500 text-medium-gray dark:border-light-gray dark:text-light-gray': !selected,
            'bg-black dark:bg-white text-white dark:text-black': selected,
            'hover:bg-medium-gray hover:text-white dark:hover:bg-white dark:hover:text-black dark:hover:child-text-black cursor-pointer': available && !disabled,
            'cursor-pointer hover:bg-gray-50 dark:hover:bg-dark-gray': !available && !disabled,
            'text-light-gray dark:text-medium-gray opacity-75': !available || disabled,
        })}>
        <span className="text-lg md:text-xl font-bold">{time}</span>
        {available && <>
            <span className={classNames('text-sm md:text-base', {
                'text-primary dark:text-primary': !selected && presentation.primary,
                'text-c-yellow': !selected && presentation.yellow,
            })}>{slot ? numbro(slot.price / 100).formatCurrency({ mantissa: 2 }) : '—'}</span>
            {presentation.deal && <span
                className="absolute top-0 left-0 bg-c-yellow py-1 px-12 uppercase font-space font-light text-xxs md:text-xs leading-tight rotate-[-45deg] -translate-x-12 translate-y-2.5 md:-translate-x-11 md:translate-y-3.5 text-black"
                style={{ letterSpacing: '0.4rem' }}>{__('book.common.deal')}</span>}
        </>}
        {!available && <span className="px-4 py-1 uppercase bg-gray-50 dark:bg-dark-gray text-xs rounded border border-red-400 dark:border-0 text-red-500 tracking-wide">{__('book.common.complete')}</span>}
        {!available && <span className="px-1 mt-1" style={{ fontSize: '0.7rem' }}>{__('book.alternatives.see')}</span>}
        {available && <span className="px-1 mt-1 opacity-75 whitespace-nowrap" style={{ fontSize: '0.7rem' }}>
            <span className="booking-slot-remaining-long">{__('book.alternatives.remaining', { count: remaining, capacity })}</span>
            <span className="booking-slot-remaining-short">{__('book.alternatives.remaining_short', { count: remaining, capacity })}</span>
        </span>}
    </button>;
}
